import { render } from "./load-more.vue?vue&type=template&id=4e37d62a"
import script from "./load-more.vue?vue&type=script&lang=js"
export * from "./load-more.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__